export default __webpack_public_path__ + "static/media/macbook2.cfcd1c80.png";